module.exports = __webpack_public_path__ + "static/media/student.2e97eb6d.svg";